"use client";

import React, { useState, useEffect, useContext } from "react";
import { Container, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import MegaMenu from "../../Common/MegaMenu"
import { canViewMegaMenu } from "../../../utils/permissions";
import { AuthContext } from "../../../context/AuthContext";

const Navbar = () => {
  const location = useLocation(); // Use `useLocation` to get the current path
  const pathname = location.pathname; // Extract `pathname` from location

  const [isToggleNavbar, setToggleNavbar] = useState(true);

  const { user, role, loading } = useContext(AuthContext);

  const handleToggleNavbar = () => {
    setToggleNavbar(!isToggleNavbar);
  };

  useEffect(() => {
    const handleScroll = () => {
      const elementId = document.getElementById("navbar");
      if (window.scrollY > 170) {
        elementId?.classList.add("sticky");
      } else {
        elementId?.classList.remove("sticky");
      }
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top" id="navbar">
        <Container>
          <Link className="navbar-brand me-xl-5 me-3" to="/">
            <img
              src="/images/landing/logo.svg"
              alt="logo"
              width={132}
              height={34}
              className="black-logo"
            />
            <img
              src="/images/white-logo.svg"
              alt="logo"
              width={132}
              height={34}
              className="white-logo"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={handleToggleNavbar}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${
              isToggleNavbar ? "" : "show"
            }`}
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  to="/"
                  className={`nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4 ${
                    pathname === "/" ? "active" : ""
                  }`}
                >
                  خانه
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="/faq"
                  className={`nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4 ${
                    pathname === "/faq" ? "active" : ""
                  }`}
                >
                  سؤالات متداول
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="/contact"
                  className={`nav-link fs-16 fw-medium text-body hover px-0 px-md-2 mx-1 mx-xl-0 px-xl-4 ${
                    pathname === "/contact" ? "active" : ""
                  }`}
                >
                  تماس
                </Link>
              </li>

              {canViewMegaMenu(user) && <MegaMenu />}
              {/*
              <li className="nav-item dropdown">
                <NavDropdown
                  title="فروشگاه آنلاین"
                  id="ecommerce-dropdown"
                  className={`nav-link ${
                    pathname.startsWith("/ecommerce") ||
                    pathname.startsWith("/products") ||
                    pathname.startsWith("/orders") ||
                    pathname.startsWith("/cart")
                      ? "active"
                      : ""
                  }`}
                >
                  <NavDropdown.Item as={Link} to="/ecommerce">
                    داشبورد فروشگاه
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Header>محصولات</NavDropdown.Header>
                  <NavDropdown.Item as={Link} to="/products-grid">محصولات (گرید)</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/products-list">محصولات (لیست)</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/products-details">جزئیات محصول</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/create-product">افزودن محصول</NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Header>سفارش‌ها</NavDropdown.Header>
                  <NavDropdown.Item as={Link} to="/orders">لیست سفارش‌ها</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/orders-details">جزئیات سفارش</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/create-details">ثبت سفارش جدید</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/tracking">پیگیری سفارش</NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Header>پرداخت</NavDropdown.Header>
                  <NavDropdown.Item as={Link} to="/cart">سبد خرید</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/checkout">تسویه حساب</NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Header>مدیریت</NavDropdown.Header>
                  <NavDropdown.Item as={Link} to="/categories">دسته‌بندی‌ها</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/customers">مشتریان</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/reviews">نظرات</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/refunds">مرجوعی‌ها</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="فروشندگان" id="sellers-dropdown">
                  <NavDropdown.Item as={Link} to="/sellers">لیست فروشندگان</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/sellers-details">جزئیات فروشنده</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/create-seller">افزودن فروشنده</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="رستوران" id="restaurant-dropdown">
                  <NavDropdown.Item as={Link} to="/dashboard/restaurant">داشبورد رستوران</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/restaurant/menus">منوها</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/restaurant/dish-details">جزئیات غذا</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="فاکتورها" id="invoices-dropdown">
                  <NavDropdown.Item as={Link} to="/invoices">لیست فاکتورها</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/invoices/details">جزئیات فاکتور</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/invoices/create">ایجاد فاکتور</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/invoices/edit">ویرایش فاکتور</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="کاربران" id="users-dropdown">
                  <NavDropdown.Item as={Link} to="/users">مدیریت کاربران</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/users/users-list">لیست کاربران</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/users/add-user">افزودن کاربر</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="پروفایل" id="profile-dropdown">
                  <NavDropdown.Item as={Link} to="/profile">پروفایل من</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/profile/teams">تیم‌ها</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/profile/projects">پروژه‌ها</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="تنظیمات" id="settings-dropdown">
                  <NavDropdown.Item as={Link} to="/settings/account-settings">تنظیمات حساب</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/settings/change-password">تغییر رمز عبور</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/settings/connections">اتصالات</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/settings/privacy-policy">حریم خصوصی</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/settings/terms-conditions">قوانین و شرایط</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="احراز هویت" id="auth-dropdown">
                  <NavDropdown.Item as={Link} to="/authentication/sign-in">ورود</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/authentication/sign-up">ثبت‌نام</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/authentication/forgot-password">فراموشی رمز</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/authentication/logout">خروج</NavDropdown.Item>
                </NavDropdown>
              </li>

              <li className="nav-item dropdown">
                <NavDropdown title="صفحات" id="pages-dropdown">
                  <NavDropdown.Item as={Link} to="/starter">صفحه شروع</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/blank-page">صفحه خالی</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/members">اعضا</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/search">جستجو</NavDropdown.Item>
                </NavDropdown>
              </li>
              */}
            </ul>

            <div className="othres d-flex align-items-center gap-3">
              <a
                href="/authentication/sign-in"
                className="btn btn-outline-primary-div py-2 px-4 fw-medium fs-16 rounded-3 d-flex align-items-center gap-1"
              >
                <i className="ri-login-box-line fs-18 lh-1"></i>
                <span>ورود</span>
              </a>

              {/* <a
                href="/authentication/sign-up"
                className="btn btn-primary-div py-2 px-4 fw-medium fs-16 text-white rounded-3 d-flex align-items-center gap-1"
              >
                <i className="ri-user-line fs-18 lh-1"></i>
                <span>Register</span>
              </a> */}
            </div>
          </div>
        </Container>
      </nav>
    </>
  );
};

export default Navbar;
